<template>
  <tk-cover center middle :show.sync="isShow" transition>
    <tk-flex center middle class="full-width full-height" @click.native="isShow = false">
      <div class="wrap">
        <img :src="url" />
      </div>
    </tk-flex>
  </tk-cover>
</template>
<script>
export default {
  name: 'view-image',
  data () {
    return {
      url: '',
      isShow: false
    }
  },
  methods: {
    show (url) {
      this.url = url
      this.isShow = true
    }
  }
}
</script>
<style scoped lang="scss">
  .wrap {
    max-height: 100%;
    max-width: 80%;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      background-color: rgba(255,255,255,.67);
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(0,0,0,.78);
    }
  }
</style>
